import client from 'api/client'

export const fetchAll = uid => client().get(
  `/user/${uid}/settings/document/tags`
)
